import { Colors } from '@src/colors';
import styled, { css } from 'styled-components';
import { NumberInput } from './NumberInput.styled';

export const Incrementer = styled.div<{ disabled?: boolean }>`
    display: flex;
    justify-content: space-between;
    padding: 4px;
    gap: 6px;
    box-sizing: border-box;

    border-radius: 100px;

    ${(props) =>
        props.disabled
            ? css`
                  background: ${Colors.grayEight};
                  border: 1px solid ${Colors.midnight70};
              `
            : css`
                  background: ${Colors.white};
                  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.15);
              `}

    > button {
        background-color: unset;
        border: none;
        outline: none;
        padding: 0;

        > svg {
            circle:hover {
                fill: ${Colors.midnight20};
            }
            circle:active {
                fill: ${Colors.midnight30};
            }
        }

        &:disabled {
            > svg {
                circle {
                    fill: ${Colors.grayEight};
                }
                path {
                    fill: ${Colors.duskTwo};
                }
            }
        }
    }

    > ${NumberInput} {
        margin: auto;
        padding: 0;
        width: 40px;
        height: unset;

        border: none;
        cursor: text;
        outline: none;
        text-align: center;

        background-color: ${Colors.white};
        &:disabled {
            background-color: ${Colors.grayEight};
        }

        &:read-only {
            cursor: default;
        }
    }
`;
